<template>
  <span :class="`sm-flag sm-icon-flag-${countryName}`"></span>
</template>

<script>
export default {
  name: 'include-flag',
  props: {
    country: String
  },
  computed: {
    countryName() {
      return this.country.toLowerCase().replace(new RegExp(' ', 'g'), '_');
    }
  }
}
</script>